import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const HippaPopUp = ({ show, onAccept }) => {
  const [agreed, setAgreed] = useState(false);

  const handleCheckboxChange = (e) => {
    setAgreed(e.target.checked);
  };

  const handleNext = () => {
    if (agreed) {
      onAccept();
    }
  };

  return (
    <Modal show={show} backdrop="static" keyboard={false} centered size="lg">
      <Modal.Header>
        <Modal.Title>Welcome to Map Your Meds</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
        <p>To protect the privacy and security of patient information, it is essential that all users of this system comply with the Health Insurance Portability and Accountability Act (HIPAA).</p>
        <p>By using this software, you agree to the following:</p>
        <ul>
          <li>I understand that this software contains Protected Health Information (PHI).</li>
          <li>I will only access information in this software when required to perform my job duties.</li>
          <li>I will only access this software when I am credentialed and authorized to do so.</li>
          <li>I will not share my login credentials with anyone.</li>
          <li>I will log out or secure my device when not in use.</li>
          <li>I will not use any unauthorized device to access this software.</li>
          <li>I will not download, store, or share PHI outside of the secure, authorized system environment.</li>
          <li>I will immediately report any suspected data breach or unauthorized access to the designated privacy officer or IT support.</li>
          <li>I understand that violating HIPAA regulations may result in disciplinary action, termination, and potential legal consequences.</li>
        </ul>
        <p>Please confirm that you understand and agree to comply with HIPAA and Mapyourmeds rules and regulations.</p>
        <Form.Check
          type="checkbox"
          id="hipaa-agree-checkbox"
          label="I have read and agree to the HIPAA Compliance Policy and will use this software in accordance with all applicable privacy and security rules."
          checked={agreed}
          onChange={handleCheckboxChange}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" disabled={!agreed} onClick={handleNext}>
          Accept
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default HippaPopUp;
